<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="70%" @opened="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px">
      <el-form-item label="日期" prop="day_time">
        <el-date-picker v-model="formData.day_time" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="经文" prop="content">
        <el-input v-model="formData.content" type="textarea" :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm" :disabled="confirmDisable">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'lection_day_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加今日经文',
      confirmDisable: false,
      formData: {
        content: '',
        day_time: ''
      },
      formRules: {
        content: [
          { required: true, message: '经文不能为空', trigger: 'blur' }
        ],
        day_time: [
          { required: true, message: '日期不能为空', trigger: 'blur' }
        ]
      },
      editorOption: {
        placeholder: '编辑今日经文内容'
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.confirmDisable = true
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑配置'
        this.getLectionDayInfo(this.id)
      }
      this.confirmDisable = false
    },
    async getLectionDayInfo (id) {
      const res = await this.$http.get('/admin/lection_day/info/' + id)
      if (res.code === 0) {
        this.formData = {
          content: res.data.content,
          day_time: res.data.day_time_str
        }
      }
    }
  }
}
</script>

<style>
</style>
